import { render } from "./subjectList.vue?vue&type=template&id=487a8298&scoped=true"
import script from "./subjectList.vue?vue&type=script&lang=js"
export * from "./subjectList.vue?vue&type=script&lang=js"

import "./subjectList.vue?vue&type=style&index=0&id=487a8298&scoped=true&lang=css"
import "./subjectList.vue?vue&type=style&index=1&id=487a8298&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-487a8298"]])

export default __exports__